"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _SanitizedHTML = require("../../SanitizedHTML");

var _Icon = require("../../Icon");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    title: {
      fontSize: 24,
      lineHeight: 1.33,
      color: palette.text.primary
    },
    icon: {
      marginRight: spacing(1)
    },
    link: {
      display: 'inline',
      textDecoration: 'none',
      color: palette.link.main,
      fontSize: 16,
      fontWeight: 500,
      '&:hover': {
        textDecoration: 'none'
      }
    },
    text: {
      wordBreak: 'break-word'
    }
  };
});

var Merchant = function Merchant(_ref2) {
  var product = _ref2.product,
      onShowMerchantWebsite = _ref2.onShowMerchantWebsite;
  var classes = useStyles();
  var handleClickMerchantWebsite = (0, _react.useCallback)(function () {
    if (onShowMerchantWebsite) {
      onShowMerchantWebsite();
    }
  }, [onShowMerchantWebsite]);
  return /*#__PURE__*/_react["default"].createElement(_material.Slide, {
    "in": true,
    direction: "left"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    px: 3,
    py: 0
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    mt: 3,
    textAlign: "left"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: classes.title
  }, "About ", product === null || product === void 0 ? void 0 : product.provider.name)), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    mb: 3,
    textAlign: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SanitizedHTML.SanitizedHTML, {
    className: (0, _classnames["default"])('Body-Regular-Left-Static', classes.text),
    html: (product === null || product === void 0 ? void 0 : product.provider.description) || ''
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    mb: 3,
    textAlign: "left"
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: classes.icon,
    icon: "link",
    color: "grey"
  }), /*#__PURE__*/_react["default"].createElement(_material.Link, {
    className: classes.link,
    href: "http://".concat(product === null || product === void 0 ? void 0 : product.provider.website),
    onClick: handleClickMerchantWebsite,
    target: "_blank",
    rel: "noopener noreferrer",
    underline: "hover"
  }, product === null || product === void 0 ? void 0 : product.provider.website))));
};

var _default = /*#__PURE__*/(0, _react.memo)(Merchant);

exports["default"] = _default;